<template>
  <v-row>
    <v-col cols="12">
      <base-card v-if="$store.state.invoice.listInvoice.length > 0">
        <v-alert
          v-show="copyAlert"
          text
          type="info"
        >
          {{ msgjsoncopiado }}
        </v-alert>
        <v-card-title>
          Listado de Facturas Electrónicas
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            hide-details
            label="Buscar"
            single-line
          />
          <v-spacer />
        </v-card-title>
        <br>
        <v-card-text>
          <div v-if="selectedInvoices.length > 0 && showSelectionMode" class="mb-4" style="position: relative;">
            <div class="text-center">
              <v-icon color="info" class="mr-2" size="24">
                mdi-file-clock
              </v-icon>
              <span class="text-subtitle-1"><strong>{{ selectedInvoices.length }}</strong> factura(s) seleccionada(s) para cambio de fecha</span>
            </div>
            <div style="position: absolute; right: 0; top: 50%; transform: translateY(-50%);">
              <v-btn
                style="background-color:rgb(204 33 40);color:white !important"
                @click="showConfirmDialog = true"
                :disabled="selectedInvoices.length === 0"
              >
                <v-icon left>
                  mdi-send
                </v-icon>
                Procesar Facturas
              </v-btn>
            </div>
          </div>

          <v-dialog
            v-model="showConfirmDialog"
            max-width="500"
            persistent
          >
            <v-card>
              <v-toolbar
                dark
                style="background-color:rgb(204 33 40);color:white !important"
              >
                <v-icon left color="white">
                  mdi-alert-circle
                </v-icon>
                Confirmar Procesamiento
              </v-toolbar>
              <v-card-text class="pt-4">
                <v-row
                  v-if="processingInvoices"
                  align-content="center"
                  class="fill-height"
                  justify="center"
                >
                  <v-col cols="10">
                    <v-col
                      class="text-subtitle-1 text-center"
                      cols="12"
                    >
                      Procesando facturas. Por favor espere un momento
                    </v-col>
                    <v-progress-linear
                      color="red darken-4"
                      height="6"
                      indeterminate
                      rounded
                    />
                  </v-col>
                </v-row>
                <div v-else>
                  <p class="text-h6 mb-2">
                    ¿Está seguro que desea procesar las facturas seleccionadas?
                  </p>
                  <p class="text-body-1">
                    Se procesarán <strong>{{ selectedInvoices.length }}</strong> factura(s) para cambio de fecha.
                  </p>
                </div>
              </v-card-text>
              <v-card-actions v-if="!processingInvoices">
                <v-spacer />
                <v-btn
                  text
                  @click="showConfirmDialog = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  style="background-color:rgb(204 33 40);color:white !important"
                  @click="confirmarProcesamiento"
                >
                  <v-icon left>
                    mdi-check
                  </v-icon>
                  Confirmar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-data-table
            :show-select="showSelectionMode"
            v-model="selectedInvoices"
            item-key="_uniqueId"
            :items-per-page="itemsPerPage"
            :footer-props="footerPropsComputed"
            :headers="headers"
            :items="invoicesWithUniqueId"
            :search="search"
            class="elevation-1"
          >
            <template v-slot:[`item.status`]="{ item }">
              <v-tooltip
                v-if="item.status === 'PCF'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="orange darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-file-clock
                  </v-icon>
                </template>
                <span>PENDIENTE CAMBIO DE FECHA</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="item.status === 'P'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="orange darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-file-send
                  </v-icon>
                </template>
                <span>PENDIENTE</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="item.status === 'RECIBIDA'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="blue darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-file-document-check
                  </v-icon>
                </template>
                <span>RECIBIDA</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="item.status === 'AUTORIZADO'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="green darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-file-check
                  </v-icon>
                </template>
                <span>AUTORIZADO</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="item.status === 'NOTIFICADO'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="green darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-email-check
                  </v-icon>
                </template>
                <span>NOTIFICADO</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="item.status === 'NO_AUTORIZADO'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="red darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-file-document-remove
                  </v-icon>
                </template>
                <span>NO AUTORIZADO</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="item.status === 'NO_NOTIFICADO'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="red darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-email-remove
                  </v-icon>
                </template>
                <span>NO NOTIFICADO</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="item.status === 'DEVUELTA'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="red darken-4"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-file-undo
                  </v-icon>
                </template>
                <span>DEVUELTA</span>
              </v-tooltip>
              <v-tooltip
                v-else
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="grey darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>{{ item.status }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.url_pdf_notification`]="{ item }">
              <v-dialog
                v-if="item.status === 'NOTIFICADO' || item.status === 'NO_NOTIFICADO'"
                max-width="1500"
                transition="dialog-bottom-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="red darken-4"
                    style="cursor: pointer"
                    v-bind="attrs"
                    @click="getDataFile(item.url_pdf_notification, 'PDF')"
                    v-on="on"
                  >
                    mdi-file-pdf-box
                  </v-icon>
                </template>
                <template v-slot:default="dialog">
                  <v-card>
                    <v-card-actions class="justify-end">
                      <v-icon
                        text
                        @click="dialog.value = false"
                      >
                        mdi-close-thick
                      </v-icon>
                    </v-card-actions>
                    <v-toolbar
                      dark
                      style="background-color:rgb(204 33 40);color:white !important"
                    >
                      PDF FACTURA [{{ item.prefix }} - {{ item.consecutive }}]
                      <v-icon
                        class="pa-4"
                        @click="downloadPDF(item.prefix + '-' + item.consecutive)"
                      >
                        mdi-download-circle
                      </v-icon>
                    </v-toolbar>
                    <v-card-text>
                      <v-row
                        v-if="progress == true"
                        align-content="center"
                        class="fill-height"
                        justify="center"
                      >
                        <v-col cols="6">
                          <v-col
                            class="text-subtitle-1 text-center"
                            cols="12"
                          >
                            Consultando y Visualizando PDF
                          </v-col>
                          <v-progress-linear
                            color="red darken-4"
                            height="6"
                            indeterminate
                            rounded
                          />
                        </v-col>
                      </v-row>
                      <div class="text-h6">
                        <v-alert
                          v-if="msgPdf"
                          class="ma-4"
                          color="red darken-4"
                          dense
                          outlined
                          text
                          type="info"
                        >
                          {{ msgPdf }}
                        </v-alert>

                        <pdf
                          v-for="i in numPages"
                          :key="i"
                          ref="myPdfComponent"
                          :page="i"
                          :src="src"
                        />
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </v-dialog>
            </template>
            <template v-slot:[`item.reprocesarFactura`]="{ item }">
              <v-dialog
                v-if="item.status === 'P'"
                max-width="700"
                transition="dialog-bottom-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="success darken-4"
                    style="cursor: pointer"
                    v-bind="attrs"
                    @click="reprocessInvoice(item)"
                    v-on="on"
                  >
                    mdi-file-move
                  </v-icon>
                </template>
                <template v-slot:default="dialog">
                  <v-card>
                    <v-toolbar
                      dark
                      style="background-color:rgb(204 33 40);color:white !important"
                    >
                      PROCESAMIENTO DE FACTURA [ {{ item.prefix }} - {{ item.consecutive }} ]
                    </v-toolbar>
                    <v-card-text>
                      <v-row
                        v-if="progress == true"
                        align-content="center"
                        class="fill-height"
                        justify="center"
                      >
                        <v-col cols="6">
                          <v-col
                            class="text-subtitle-1 text-center"
                            cols="12"
                          >
                            Reprocesando factura . Por favor espere un momento
                          </v-col>
                          <v-progress-linear
                            color="red darken-4"
                            height="6"
                            indeterminate
                            rounded
                          />
                        </v-col>
                      </v-row>
                      <div class="text-h6">
                        <json-viewer
                          v-if="reponseReprocessData != ''"
                          :value="reponseReprocessData"
                          copyable="true"
                        >
                          <template
                            v-if="progress == false"
                            v-slot:copy
                          >
                            Copiar
                            <v-icon
                              class="mr-2"
                              color="info darken-3"
                              style="cursor: pointer"
                            >
                              mdi-content-copy
                            </v-icon>
                          </template>
                        </json-viewer>
                      </div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                      <v-btn
                        text
                        @click="dialog.value = false;"
                      >
                        Cerrar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </template>
              </v-dialog>
            </template>

            <template v-slot:[`item.reenviarEmail`]="{ item }">
              <v-icon
                v-if="item.status === 'NOTIFICADO' || item.status === 'AUTORIZADO' || item.status === 'NO_NOTIFICADO'"
                class="mr-2"
                color="orange darken-3"
                style="cursor:pointer;"
                @click="openEmailDialog(item)"
              >
                mdi-email-fast
              </v-icon>
            </template>

            <template v-slot:[`item.access_key`]="{ item }">
              <v-icon
                v-if="item.access_key !== ''"
                v-clipboard:copy="item.access_key"
                v-clipboard:success="onCopy"
                class="mr-2"
                color="info darken-3"
                style="cursor: pointer"
              >
                mdi-content-copy
              </v-icon>
            </template>
            <template v-slot:[`item.detalleFactura`]="{ item }">
              <v-icon
                v-if="item.access_key !== ''"
                class="mr-2"
                color="info darken-3"
                style="cursor: pointer"
                @click="openDetailModal(item)"
              >
                mdi-folder-search
              </v-icon>
            </template>
            <template v-slot:[`item.url_xml_reception`]="{ item }">
              <v-icon
                v-if="item.status !== 'P' && item.status !== 'PCF'"
                class="mr-2"
                color="brown darken-3"
                style="cursor: pointer"
                @click="getDataFile(item.url_xml_reception, 'UrlXMLRecepcion [' + item.prefix + item.consecutive + ']')"
              >
                mdi-folder-zip
              </v-icon>
            </template>
            <template v-slot:[`item.url_xml_authorization`]="{ item }">
              <v-icon
                v-if="item.status !== 'P' && item.status !== 'PCF'"
                class="mr-2"
                color="brown darken-3"
                style="cursor: pointer"
                @click="getDataFile(item.url_xml_authorization, 'UrlXMLAutorizacion [' + item.prefix + item.consecutive + ']')"
              >
                mdi-folder-zip
              </v-icon>
            </template>
            <template v-slot:[`item.cambiarEstado`]="{ item }">
              <v-tooltip
                v-if="canChangeStatusDocuments && hasValidTransitions(item)"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="purple darken-2"
                    style="cursor: pointer"
                    v-bind="attrs"
                    v-on="on"
                    @click="openChangeStatusModal(item)"
                  >
                    mdi-swap-horizontal
                  </v-icon>
                </template>
                <span>Cambiar estado de factura</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </base-card>
    </v-col>
    
    <!-- Modal de Detalle de Factura -->
    <invoice-detail-modal
      :visible="showDetailModal"
      :invoice-item="selectedInvoiceForDetail"
      @close="closeDetailModal"
    />

    <!-- Modal de Resultados-->
    <process-results-modal
      :visible="showResultsModal"
      :resultados="resultadosProcesamiento"
      :alert-message="alertMessage"
      :alert-type="alertType"
      title="Resultados del Procesamiento de Facturas Pendientes por cambio de Fecha"
      @close="closeResultsModal"
    />

    <!-- Modal de Cambio de Estado -->
    <change-status-modal
      :visible="showChangeStatusModal"
      :invoice-item="selectedInvoiceForStatusChange"
      @close="closeChangeStatusModal"
      @status-changed="handleStatusChanged"
    />

    <!-- Modal de Envío de Correo -->
    <send-email-modal
      :visible="showEmailDialog"
      :invoice-item="selectedItemForEmail"
      @close="closeEmailDialog"
    />
  </v-row>
</template>
<script>
  import pdf from 'vue-pdf'
  import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
  import { columnsRoles } from '@/data/columnsRoles'
  import { getValidTransitions } from '@/data/statusTransitions'
  import { mapState } from 'vuex'

  export default {
    name: 'ShowInvoices',
    components: {
      pdf,
      InvoiceDetailModal: () => import('./InvoiceDetailModal'),
      ProcessResultsModal: () => import('./ProcessResultsModal'),
      ChangeStatusModal: () => import('./ChangeStatusModal'),
      SendEmailModal: () => import('./SendEmailModal'),
    },

    data () {
      return {
        progress: false,
        src: '',
        msgPdf: '',
        reponseReprocessData: '',
        numPages: 0,
        page: 1,
        currentPage: 0,
        singleSelect: false,
        selected: [],
        search: '',
        copyAlert: false,
        size: 300,
        msgjsoncopiado: 'Copiado',
        showDetailModal: false,
        selectedInvoiceForDetail: {},
        processingInvoices: false,
        showConfirmDialog: false,
        showResultsModal: false,
        resultadosProcesamiento: [],
        alertMessage: '',
        alertType: 'success',
        copyAlertPCF: false,
        showChangeStatusModal: false,
        selectedInvoiceForStatusChange: {},
        showEmailDialog: false,
        selectedItemForEmail: {},
      }
    },
    computed: {
      ...mapState('invoice', [
        'listInvoice',
        'fileBase64',
        'fileName',
        'responseReprocess',
      ]),
      // Agregar campo único a cada factura
      invoicesWithUniqueId() {
        return this.listInvoice.map(item => ({
          ...item,
          _uniqueId: `${item.company_id}_${item.prefix}_${item.consecutive}`
        }))
      },
      headers() {
        let baseHeaders = [...columnsRoles]
        // fecha autorización después de "Fecha Creación"
        if (this.shouldShowAuthorizationDate) {
          const insertIndex = baseHeaders.findIndex(h => h.value === 'created_at') + 1
          baseHeaders.splice(insertIndex, 0, {
            text: 'Fecha Autorización',
            value: 'authorized_at'
          })
        }
        // Ocultar columnas de acción si ninguna factura muestra el ícono correspondiente
        const hiddenColumns = []
        if (!this.shouldShowChangeStatus) hiddenColumns.push('cambiarEstado')
        if (!this.shouldShowPdf) hiddenColumns.push('url_pdf_notification')
        if (!this.shouldShowResendEmail) hiddenColumns.push('reenviarEmail')
        if (!this.shouldShowReprocess) hiddenColumns.push('reprocesarFactura')
        if (hiddenColumns.length > 0) {
          baseHeaders = baseHeaders.filter(h => !hiddenColumns.includes(h.value))
        }

        return baseHeaders
      },
      shouldShowAuthorizationDate() {

        return this.listInvoice.some(item => item.authorized_at)
      },
      shouldShowChangeStatus() {
        return this.canChangeStatusDocuments && this.listInvoice.some(item => {
          const transitions = getValidTransitions(item.status)
          return transitions && transitions.length > 0
        })
      },
      shouldShowPdf() {
        return this.listInvoice.some(item =>
          item.status === 'NOTIFICADO' || item.status === 'NO_NOTIFICADO'
        )
      },
      shouldShowResendEmail() {
        return this.listInvoice.some(item =>
          item.status === 'NOTIFICADO' || item.status === 'AUTORIZADO' || item.status === 'NO_NOTIFICADO'
        )
      },
      shouldShowReprocess() {
        return this.listInvoice.some(item => item.status === 'P')
      },
      // Determina si debe mostrar el modo de selección (checkboxes)
      showSelectionMode() {
        return this.$store.state.invoice.currentFilterStatus === 'PCF'
      },
      selectedInvoices: {
        get() {
          return this.$store.state.invoice.selectedInvoices
        },
        set(value) {
          this.$store.commit('invoice/setSelectedInvoices', value)
        }
      },
      // Configuración dinámica de paginación
      itemsPerPage() {
        // Si está en modo selección PCF, mostrar todas las facturas
        return this.showSelectionMode ? -1 : 10
      },
      footerPropsComputed() {
        if (this.showSelectionMode) {
          return {
            'items-per-page-text': 'Mostrando todas las facturas',
            'items-per-page-options': [-1]
          }
        }
        return {
          'items-per-page-text': 'filas por pagina',
          'items-per-page-options': [5, 10, 15, -1]
        }
      },
      canChangeStatusDocuments() {
        const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
        return permissions.includes('Cambiar Estado Documentos')
      },
    },
    watch: {
      fileBase64 () {
        if (this.fileName === 'PDF') {
          this.msgPdf = ''
          if (this.fileBase64.Datos !== '') {
            this.previewPDF()
          } else {
            this.msgPdf = 'El PDF aún no está disponible. Inténtelo más tarde.'
          }
        } else if (!this.showDetailModal) {
          // Solo descargar XMLs si el modal de detalle NO está abierto
          this.downloadFile(this.fileName)
        }
      },
      responseReprocess () {
        this.showReprocess()
      },
    },
    created () {
      this.$store.commit('invoice/setListInvoice', [])
    },
    methods: {
      openEmailDialog (item) {
        this.selectedItemForEmail = item
        this.showEmailDialog = true
      },
      closeEmailDialog () {
        this.showEmailDialog = false
        this.selectedItemForEmail = {}
      },
      showReprocess () {
        this.progress = false
        this.reponseReprocessData = this.responseReprocess
      },
      previewPDF () {
        this.progress = false
        const database64 = 'data:application/pdf;base64,' + this.fileBase64.Datos
        this.src = pdf.createLoadingTask({ url: database64, CMapReaderFactory })
        this.src.promise.then((pdf) => {
          this.numPages = pdf.numPages
        })
      },
      onCopy (e) {
        this.generateAlertCopy()
      },
      generateAlertCopy () {
        this.copyAlert = true
        setTimeout(() => {
          this.copyAlert = false
        }, 2000)
      },
      async getListInvoice () {
        await this.$store.dispatch('invoice/getListInvoice')
      },
      async reprocessInvoice (item) {
        this.reponseReprocessData = ''
        this.progress = true
        await this.$store.dispatch('invoice/reprocessInvoice', {
          IdCompania: item.company_id,
          Prefijo: item.prefix,
          Consecutivo: item.consecutive,
        })
      },
      async getDataFile (file, name) {
        this.src = ''
        if (!file) {
          this.progress = false
          if (name === 'PDF') {
            this.msgPdf = 'El PDF aún no está disponible. Inténtelo más tarde.'
          }
          return
        }
        const datos = { url: file, nameFile: name }
        this.msgPdf = ''
        this.progress = true
        await this.$store.dispatch('invoice/getDataFile', datos)
      },
      downloadPDF (name) {
        const linkSource = 'data:application/pdf;base64,' + this.fileBase64.Datos
        const downloadLink = document.createElement('a')
        const fileName = name + '.pdf'
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      },

      async downloadFile (name) {
        const linkSource = 'data:application/zip;base64,' + this.fileBase64.Datos
        const downloadLink = document.createElement('a')
        const fileName = name + '.zip'
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      },
      openDetailModal(item) {
        this.selectedInvoiceForDetail = item
        this.showDetailModal = true
      },
      closeDetailModal() {
        this.showDetailModal = false
        this.selectedInvoiceForDetail = {}
      },
      closeResultsModal() {
        this.showResultsModal = false
        this.resetAlert()
      },
      async confirmarProcesamiento() {
        if (this.selectedInvoices.length === 0) {
          return
        }

        this.processingInvoices = true
        this.resetAlert()

        try {
          const IdCompania = this.selectedInvoices[0].company_id

          const documentos = this.selectedInvoices.map(factura => ({
            Prefijo: factura.prefix,
            Consecutivo: factura.consecutive,
          }))

          const payload = {
            IdCompania,
            documentos
          }

          const response = await this.$store.dispatch('invoice/procesarFacturasPCF', payload)

          // Procesar la respuesta
          if (response && response.Datos && Array.isArray(response.Datos)) {
            this.resultadosProcesamiento = response.Datos.map((item) => ({
              IdCompania: item.IdCompania,
              consecutivo: item.consecutivo,
              status: item.status,
              mensaje: item.mensaje,
              procesamiento: item.procesamiento
            }))

            this.showConfirmDialog = false
            this.showResultsModal = true

            this.setAlert('success', `Se procesaron ${documentos.length} factura(s) exitosamente.`)

            // Limpiar selección después del procesamiento
            this.$store.commit('invoice/setSelectedInvoices', [])
          } else {
            throw new Error('Estructura de respuesta inesperada')
          }

        } catch (error) {
          console.error('Error al procesar facturas:', error)
          this.setAlert('error', 'Error al procesar las facturas')
          this.showConfirmDialog = false
        } finally {
          this.processingInvoices = false
        }
      },

      setAlert(type, message) {
        this.alertType = type
        this.alertMessage = message
      },

      resetAlert() {
        this.alertMessage = ''
        this.alertType = 'success'
      },
      hasValidTransitions(item) {
        const transitions = getValidTransitions(item.status)
        return transitions && transitions.length > 0
      },
      openChangeStatusModal(item) {
        this.selectedInvoiceForStatusChange = item
        this.showChangeStatusModal = true
      },
      closeChangeStatusModal() {
        this.showChangeStatusModal = false
        this.selectedInvoiceForStatusChange = {}
      },
      handleStatusChanged(data) {
        // Refrescar la lista de facturas
        const lastFilterParams = this.$store.state.invoice.lastFilterParams
        if (lastFilterParams) {
          this.$store.dispatch('invoice/getListInvoice', lastFilterParams)
        }
        this.$emit('status-changed', data)
      },
    },
  }
</script>

<style scoped>
</style>
